import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { connect } from 'react-redux';
import baseStyles from '../../PropertiesMenuStyles';
import styles from './FontPropertyStyles';
import {TYPES, PROPERTY_PANELS} from 'crazyEditor/core/constants/panelConstants';
import { openLazyPanel } from 'crazyEditor/redux/modules/panel/panel';
import { updateDesktopElement } from 'crazyEditor/redux/modules/element/actions/desktopElementActions';
import { updateMobileElement } from 'crazyEditor/redux/modules/element/actions/mobileElementActions';
import editorConstants from 'crazyEditor/core/constants/editorConstants';
import CustomSvgButtonWithTextPropMenu from '../../shared/CustomSvgButtonWithTextPropMenu';
import CustomSvgIconButtonPropMenu from '../../shared/CustomSvgIconButtonPropMenu';
import FontEmphasisAndAlign from './FontEmphasisAndAlign';
import { getElementDefinitionProps } from 'crazyEditor/core/elements/utils/elementDefinitionUtils';

@connect(
  false,
  {openLazyPanel, updateDesktopElement, updateMobileElement}
)
@Radium
export default class FontProperty extends Component {

  openFontPanel = (event, panel, panelProps = {}) => {
    const {openLazyPanel, selectedElementIds, selectedElements} = this.props;
    openLazyPanel(panel, TYPES.PROPERTY_PANEL, event.currentTarget, {
      selectedElementIds: selectedElementIds,
      selectedElements: selectedElements,
      ...panelProps
    });
  };

  updateElement = (updateGetter) => {
    const {updateDesktopElement, updateMobileElement, isMobileView} = this.props;
    const element = this.props.selectedElements[0];
    const updateFn = isMobileView ? updateMobileElement : updateDesktopElement;
    updateFn(element.id, updateGetter(element));
  };

  render() {
    const { isMobileView, selectedElements } = this.props;
    const element = selectedElements[0];
    const elementDefinitionProps = getElementDefinitionProps(element);
    return (
      <div style={[baseStyles.menuContainer, this.props.first && baseStyles.menuContainerFirst]}>
        <div style={baseStyles.menuTitle}>Text</div>
        <div style={baseStyles.menuBody}>
          {!isMobileView &&
          [<CustomSvgButtonWithTextPropMenu label="Font"
                                            key="Font"
                                            iconWidth="36px"
                                            iconHeight="36px"
                                            onClick={(event) => this.openFontPanel(event, PROPERTY_PANELS.FONT_FAMILY)}
                                            iconPath="M5,4V7H10.5V19H13.5V7H19V4H5Z"/>,
            <CustomSvgButtonWithTextPropMenu label="Size"
                                             key="Size"
                                             iconWidth="36px"
                                             iconHeight="36px"
                                             onClick={(event) => this.openFontPanel(event, PROPERTY_PANELS.FONT_SIZE)}
                                             iconPath="M3,12H6V19H9V12H12V9H3M9,4V7H14V19H17V7H22V4H9Z"/>]
          }
          {isMobileView &&
          <CustomSvgButtonWithTextPropMenu label="Size"
                                           iconWidth="36px"
                                           iconHeight="36px"
                                           onClick={(event) => this.openFontPanel(event, PROPERTY_PANELS.MOBILE_FONT_SIZE)}
                                           iconPath="M3,12H6V19H9V12H12V9H3M9,4V7H14V19H17V7H22V4H9Z"/>

          }
          {!isMobileView &&
          <CustomSvgButtonWithTextPropMenu label="Color"
                                           iconWidth="24px"
                                           iconHeight="24px"
                                           iconProps={{
                                             viewBox: '0 0 30 30'
                                           }}
                                           lineBackground={_.get(element, 'data.compProps.color') || 'transparent'}
                                           onClick={(event) => this.openFontPanel(event, PROPERTY_PANELS.COLOR, {propNameToUpdate: 'data.compProps.color'})}
                                           iconPath="M17.6,18H11.4L10,22H5L12.4,2h4.21L24,22H19Zm-5.3-4h4.4L14.5,7Z"/>
          }
          {
            (!elementDefinitionProps.mobileFontSizeOnly || !isMobileView ) && !elementDefinitionProps.noFontEmphasisAndAlign &&
              [
                <span key="1" style={[{display: 'none'}, !isMobileView && styles.fontMoreActionsPanel]}>
                  <CustomSvgButtonWithTextPropMenu
                    label="More"
                    iconWidth="36px"
                    iconHeight="36px"
                    iconPath="M16,12A2,2 0 0,1 18,10A2,2 0 0,1 20,12A2,2 0 0,1 18,14A2,2 0 0,1 16,12M10,12A2,2 0 0,1 12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12M4,12A2,2 0 0,1 6,10A2,2 0 0,1 8,12A2,2 0 0,1 6,14A2,2 0 0,1 4,12Z"
                    onClick={(event) => this.openFontPanel(event, PROPERTY_PANELS.FONT_MORE_ACTIONS, {isMobileView: isMobileView, selectedElements: selectedElements})}
                  />
                </span>,
                <span key="2" style={[{display: 'inline-block'}, !isMobileView && styles.fontEmphasisAndAlign]}>
                  <FontEmphasisAndAlign isMobileView={isMobileView}/>
                </span>
              ]
          }
        </div>
      </div>
    );
  }
}

FontProperty.propTypes = {
  selectedElementIds: PropTypes.array.isRequired,
  selectedElements: PropTypes.array.isRequired,
  isMobileView: PropTypes.bool
};

FontProperty.defaultProps = {
  isMobileView: false
};